// Find a lift: search by name or muscle, grouped by muscle, or write in your own.
// Shared by the program editor and the workout logger (plan v4 item 3).
import { loadExerciseLibrary, createExercise } from '../lib/grit-data.js';
import { displayName, displayNameHtml } from '../lib/exercise-names.js';
import { toast } from './toast.js';
import { icon } from './icons.js';
import { openLiftForm } from './lift-form.js';

const PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

// onPick(exercise, custom) gets the chosen library row; custom holds the numbers of a written-in lift.
export async function openExercisePicker({ title = 'Add a lift', usedIds = new Set(), onPick }) {
  const lib = await loadExerciseLibrary();
  let q = '';

  const overlay = document.createElement('div');
  overlay.className = 'fixed inset-0 z-[130] flex items-end justify-center bg-black/30';
  document.body.appendChild(overlay);
  const close = () => overlay.remove();
  overlay.addEventListener('click', (e) => { if (e.target === overlay) close(); });

  function listHtml() {
    const filtered = lib.filter((x) => !q || displayName(x).toLowerCase().includes(q) || x.name.toLowerCase().includes(q) || (x.muscle_group || '').toLowerCase().includes(q));
    const groups = {};
    for (const x of filtered) { (groups[x.muscle_group || 'other'] ||= []).push(x); }
    return Object.keys(groups).map((mg) => `<div class="mb-3">
      <div class="grit-eyebrow mb-1 capitalize">${mg}</div>
      ${groups[mg].map((x) => `<button data-add="${x.id}" class="grit-row w-full text-left flex items-center justify-between gap-2 min-h-[48px] border-t border-hairline first:border-0 px-1">
        <span class="text-[17px] text-ink">${displayNameHtml(x)}${usedIds.has(x.id) ? ' <span class="text-[13px] text-inksoft">· already in this workout</span>' : ''}</span>
        <span class="text-grit flex-none">${PLUS}</span></button>`).join('')}
    </div>`).join('') || '<div class="text-[15px] text-inksoft text-center py-4">No matches. Write it in below.</div>';
  }

  function paint() {
    overlay.innerHTML = `<div class="grit-sheet">
      <div class="grit-sheet-handle"></div>
      <div class="flex items-center justify-between mb-2">
        <div class="text-[20px] font-bold tracking-tight text-ink">${title}</div>
        <button data-close aria-label="Close" class="text-inksoft w-11 h-11 -mr-2 flex items-center justify-center">${icon.x('w-5 h-5')}</button>
      </div>
      <input id="pq" placeholder="Search lifts or muscles" value="${q.replace(/"/g, '&quot;')}" aria-label="Search lifts" class="grit-input mb-2" />
        <div class="overflow-y-auto flex-1 -mx-1 px-1">${listHtml()}</div>
        <button id="custom" class="grit-btn-quiet mt-2 !text-grit">Write in a lift</button>
    </div>`;
    overlay.querySelectorAll('[data-close]').forEach((b) => { b.onclick = close; });
    const pq = overlay.querySelector('#pq');
    pq.oninput = () => { q = pq.value.toLowerCase(); const sel = pq.selectionStart; paint(); const np = overlay.querySelector('#pq'); np.focus(); np.setSelectionRange(sel, sel); };
    overlay.querySelectorAll('[data-add]').forEach((b) => { b.onclick = () => { const ex = lib.find((x) => x.id === b.dataset.add); close(); onPick?.(ex); }; });
    overlay.querySelector('#custom').onclick = () => {
      close();
      openLiftForm({
        name: q ? q.replace(/\b\w/g, (c) => c.toUpperCase()) : '', saveLabel: 'Add this lift',
        onSave: async (v) => {
          const ex = await createExercise({ name: v.name, muscle_group: v.muscle, equipment: v.equipment, tracking: v.tracking, default_rep_low: v.lo, default_rep_high: v.hi, default_increment_lb: v.inc });
          if (!ex) { toast("Couldn't save it, try again", { tone: 'bad' }); return; }
          onPick?.(ex, v);
        },
      });
    };
  }
  paint();
}
